@if (!loading) {
<app-service-details [serviceCodeAndCategory]="serviceCodeAndCategory"
    [existingChargeItemDefinition]="existingChargeItemDefinition"
    [existingActivityDefinition]="existingActivityDefinition">
</app-service-details>
} @else {
...loading
}